import {getManager} from "../Manager";
import {StorageName} from "../StorageManager";
import {IStringObject} from "../../common/SimpleInterface";
import {isArray, isNativeObject} from "../../common/SiteHelper";
import {LocateDataChoice} from "../../data/locate/LocateDataFactory";
import {ILocatableDataChoices} from "../../data/locate/LocatableDataFactory";

export interface IKeyValue
{
    key: string;
    value: any
}

export class KeyValueStore
{
    list: IKeyValue[] = [];
    object: IStringObject = {};
    defaultKey:string|null = null
    defaultValue:any|null = null
}

export default class ConfigManager
{
    storageName:StorageName = "config";
    initialized = false;
    configVersion = "";
    locationCountryStore:KeyValueStore = new KeyValueStore();
    postSplitCountryCode:string|null = null

    async getConfigVersion()
    {
        if(this.configVersion){
            return this.configVersion
        }
        return getManager().storage.get("api_home", this.storageName).then(async apiHome =>
        {
            if(apiHome === getManager().api.apiHome){
                this.configVersion = await getManager().storage.get("config_version", this.storageName);
            } else {
                this.configVersion = "";
            }
            return this.configVersion;
        });
    }


    applyConfig(config:any)
    {
        if(isNativeObject(config)){

            const lists = config.lists;

            getManager().app.site.applyDetails(config.site);

            const postFields = config.post_fields ?? {};

            if(isNativeObject(postFields)){
                getManager().post.applyPostFieldConfigs(postFields);
            }


            if(isNativeObject(lists))
            {
                this.applyToStore(lists.location_country, this.locationCountryStore);
                if(Array.isArray(lists.location_country)){
                    for(let i = 0; i < lists.location_country.length; i++)
                    {
                        const countryObject = lists.location_country[i];
                        const countryCode = countryObject.key;
                        if(countryObject.post_split){
                            if(this.locationCountryStore.object[countryCode]){
                                this.postSplitCountryCode = countryCode;
                                break;
                            }
                        }
                    }
                }
            }


            this.initialized = true;
            return null;
        }
        return "Invalid Config [1]";
    }

    applyToStore(fromObject:any, toStore:KeyValueStore, expectsDefault:boolean = false, defaultKey:any|null = null): void
    {
        toStore.object = {};
        toStore.list.length = 0;
        if(!fromObject || !Array.isArray(fromObject)){
            return;
        }

        let defaultFound = false;
        let firstKey: any = null;
        for(let i = 0; i < fromObject.length; i++)
        {
            const entry = fromObject[i];
            if(!entry.hasOwnProperty("key") || !entry.hasOwnProperty("value")){
                continue;
            }
            const key = entry.key;
            const value = entry.value;
            toStore.object[key] = value;
            toStore.list.push({
                key: key,
                value: value
            })
            if(firstKey === null){
                firstKey = key;
            }
            if(defaultKey === key){
                defaultFound = true;
            }
        }
        if(!defaultFound)
        {
            defaultKey = null;
        }
        if(defaultKey === null && expectsDefault && firstKey !== null){
            defaultKey = firstKey;
        }
        toStore.defaultKey = defaultKey;
        toStore.defaultValue = defaultKey ? toStore.object[defaultKey] : null;
    }

    dummyConfig()
    {
        return {}
    }


    async applyLocalConfig()
    {
        return getManager().storage.get("config", this.storageName).then(config => {
            let applyConfigError = this.applyConfig(config);
            if(!applyConfigError){
                return null;
            }
            if(getManager().app.noServerAvailable){
                applyConfigError = this.applyConfig(this.dummyConfig());
                if(!applyConfigError){
                    return null;
                }
            }

            this.configVersion = "";
            return getManager().storage.remove("config_version", this.storageName).then(_ => {
                return getManager().storage.remove("config", this.storageName).then(_ => {
                    return applyConfigError;
                })
            })
        });
    }

    async applyConfigResponse(configResponse:any)
    {
        if(isNativeObject(configResponse)){
            const isVersionMatch = !!configResponse.is_version_match;
            if(isVersionMatch){
                return this.applyLocalConfig();
            }
            const configVersion = configResponse.version;
            const config = configResponse.config;
            if(configVersion && isNativeObject(config)){
                const applyConfigError = this.applyConfig(config);
                if(applyConfigError){
                    return applyConfigError;
                }
                return getManager().storage.set("config", config, this.storageName).then(async _ =>
                {
                    await getManager().storage.set("config_version", configVersion, this.storageName);
                    await getManager().storage.set("api_home", getManager().api.apiHome, this.storageName);
                    this.configVersion = configVersion;
                    return null;
                });
            }
        }
        return "Invalid Config [2]";
    }
}